import React from 'react';
import styled from 'styled-components';

const TestContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const TestHeader = styled.div`
  margin-bottom: 2rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  margin-bottom: 0.5rem;
`;

const Description = styled.p`
  color: #666;
`;

const TestContent = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #eee;
`;

/**
 * TestPage Component
 * 
 * A generic test page that can be used to showcase and test various components
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - The title of the test page
 * @param {string} props.description - Description of what's being tested
 * @param {React.ReactNode} props.children - The component(s) to be tested
 */
const TestPage = ({ 
  title = "Component Test Page", 
  description = "This page is used to test and showcase components.", 
  children 
}) => {
  return (
    <TestContainer>
      <TestHeader>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TestHeader>
      <TestContent>
        {children}
      </TestContent>
    </TestContainer>
  );
};

export default TestPage;
